export default {
  hero_title: '情報セキュリティ方針',
  hero_desc: 'AIX JAPAN株式会社は、お客様および社会からの信頼を守るため、\n情報セキュリティの確保を最重要事項として取り組んでいます。',
  compliance_title: '準拠規格・取り組み',
  compliance_iso: 'ISO/IEC 27001',
  compliance_iso_desc: '情報セキュリティ\nマネジメントシステム',
  compliance_isms: 'ISMS認証',
  compliance_isms_desc: '情報セキュリティ\n管理基準に準拠',
  compliance_privacy: '個人情報保護法',
  compliance_privacy_desc: '関連法令・ガイドライン\nを完全遵守',
  badge_prep: '資格取得準備中',

  meta_title: '情報セキュリティ方針 | AIX JAPAN – ISO27001準拠・ISMS取得準備',
  meta_description: 'AIX JAPAN株式会社の情報セキュリティ方針。ISO/IEC 27001・ISMS認証取得準備中。顧客情報・業務情報の適切な保護とサイバーセキュリティ対策に全社で取り組んでいます。',
  meta_keywords: '情報セキュリティ,ISMS,ISO27001,セキュリティポリシー,AIX JAPAN',

  declaration: '「AIで社会を変える」使命を果たすために、\nすべての情報資産を適切に守り、\nお客様との信頼関係を永続的に維持します。',
  declaration_author: 'AIX JAPAN株式会社　代表取締役　鈴木 章史',
  date_established: '制定日：2026年4月1日',
  company_name: 'AIX JAPAN株式会社',

  policies: [
    { icon: 'ri-shield-check-line', title: '基本方針', content: 'AIX JAPAN株式会社（以下「当社」）は、AIコンサルティング・DX推進・AI人材育成事業を通じて、お客様・パートナー・従業員をはじめとするすべてのステークホルダーの情報資産を適切に保護することを経営上の最重要課題のひとつとして位置づけます。' },
    { icon: 'ri-lock-line', title: '情報資産の保護', content: '当社が保有・管理するすべての情報資産（顧客情報・従業者情報・業務情報・システム等）について、機密性・完全性・可用性を確保するための適切な管理措置を講じます。' },
    { icon: 'ri-user-settings-line', title: '組織体制・教育', content: '情報セキュリティ推進体制を整備し、責任者を明確にします。また、全従業員に対して定期的な情報セキュリティ教育・訓練を実施し、情報セキュリティ意識の向上と適切な行動を促します。' },
    { icon: 'ri-alert-line', title: 'インシデント対応', content: '情報セキュリティインシデントが発生した場合、または発生するおそれがある場合は、速やかに対応手順に従い被害の拡大防止・復旧・再発防止に取り組みます。' },
    { icon: 'ri-file-list-3-line', title: '法令・規範の遵守', content: '情報セキュリティに関する法令・規制・業界標準・契約上の義務を遵守します。個人情報保護法をはじめとする関連法規を適切に理解し、コンプライアンスの徹底を図ります。' },
    { icon: 'ri-refresh-line', title: '継続的な改善', content: '情報セキュリティ管理の有効性を定期的に見直し、リスクの変化や技術動向に対応した継続的な改善を行います。情報セキュリティ監査を定期的に実施し、問題点の早期発見と改善を図ります。' },
    { icon: 'ri-cloud-line', title: 'クラウド・AIシステムのセキュリティ', content: 'AI・クラウド技術を活用したサービス提供において、クラウドサービスの適切な設定・管理、AIモデルへのアクセス制御、生成AIを通じた情報漏洩防止等、最新の脅威に対応したセキュリティ対策を講じます。' },
    { icon: 'ri-building-2-line', title: '物理的セキュリティ', content: '当社オフィスおよびサーバー室等の重要エリアへの入退室管理を適切に行い、物理的な情報資産への不正アクセスを防止します。モバイル端末・記録媒体の適切な管理・廃棄を徹底します。' },
  ],
};